import { useCallback } from "react";

import {
  createFileRoute,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";
import { z } from "zod";

import { Route as SignInRoute } from "@app/navigation/routes/_public/sign-in";
import { ChangePasswordConnector } from "@pages/change-password";
import { ResetPasswordConnector } from "@pages/reset-password";
import { emailSchema } from "@shared/libs/validators";

export const Route = createFileRoute("/_public/password-reset")({
  component: RouteComponent,
  validateSearch: z.object({
    email: emailSchema.optional().catch(undefined),
    resetCode: z.string().optional().catch(undefined),
  }),
});

function RouteComponent() {
  const router = useRouter();
  const { email, resetCode } = Route.useSearch();

  const navigate = useNavigate();

  const handleSuccessReset = useCallback(async () => {
    await navigate({
      to: SignInRoute.fullPath,
    });
  }, [navigate]);

  const handleResendLink = useCallback(async () => {
    await navigate({
      replace: true,
      search: (prev) => ({
        ...prev,
        resetCode: undefined,
      }),
      to: Route.fullPath,
    });
  }, [navigate]);

  if (resetCode) {
    return (
      <ChangePasswordConnector
        resetCode={resetCode}
        onResendLink={handleResendLink}
        onSignIn={handleSuccessReset}
      />
    );
  }

  return (
    <ResetPasswordConnector email={email} onGoBack={router.history.back} />
  );
}
